<template>
    <router-view />
</template>
<script>
export default {
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>


// WEBPACK FOOTER //
// src/layouts/RouterView.vue